import React from "react";
import { Link } from "react-router-dom";
import sidebarHelper from "../../../helpers/sidebar";

export default function CoworkerSitePublisherMenu({ activeItem = null }) {
  return (
    <>
      <li className="nav-item">
        <Link
          to="/publishers/coworker/"
          className={`nav-link  d-flex
                          ${sidebarHelper.checkActiveItem(
                            activeItem,
                            "all-site-publisher-coworker"
                          )} `}
        >
          <i className="nav-icon hl-view-circle"></i>
          <p> نماش دهنده ها </p>
        </Link>
      </li>
    </>
  );
}
